import { ExternalLink, Users } from 'lucide-react';
import { GS_APP_URLS } from '@gs/config/browser';
import { Trans, useTranslation } from '../i18n';

// Troisieme porteur de l'adresse d'admin, apres la tuile du catalogue et l'item
// de barre laterale — et le seul a lire un `VITE_ADMIN_HUB_URL` qui n'etait
// declare NULLE PART (ni `vite-env.d.ts`, ni `clientEnvSchema`), avec l'URL
// Azure brute en repli. Une variable jamais definie ne prend jamais le dessus :
// le repli etait la vraie valeur, et c'etait la mauvaise origine
// (E-20260901-hub-admin-deux-cibles).

export default function UsersPage() {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col items-center justify-center rounded-2xl border border-slate-200 bg-white px-8 py-16 text-center">
      <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-purple-50">
        <Users className="h-7 w-7 text-purple-500" />
      </div>
      <h2 className="text-lg font-semibold text-slate-800">{t('hub:users.title')}</h2>
      <p className="mt-2 max-w-sm text-sm text-slate-500 leading-relaxed">
        <Trans
          i18nKey="hub:users.description"
          components={{ strong: <strong className="text-slate-700" /> }}
        />
      </p>
      <a
        href={`${GS_APP_URLS.admin}/utilisateurs`}
        target="_blank"
        rel="noopener noreferrer"
        className="mt-6 inline-flex items-center gap-2 rounded-lg bg-slate-800 px-5 py-2.5 text-sm font-medium text-white transition-colors hover:bg-slate-700"
      >
        <ExternalLink className="h-4 w-4" />
        {t('hub:users.openAdmin')}
      </a>
    </div>
  );
}
